import React from "react";
import { PatientEnrollment, PatientOverview } from "../../../components/super-admin-dashboard";
import styles from "../SuperAdminDashboardPage.module.css";

const ClinicalOverviewTab = ({ scope }) => {
  return (
    <div className={styles.clinicalContainer}>
      <PatientEnrollment scope={scope} />
      <PatientOverview scope={scope} />
    </div>
  );
};

export default ClinicalOverviewTab;
